import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider as ReduxProvider } from "react-redux";
import store from './redux/store';
import 'react-toastify/dist/ReactToastify.css';
import { Auth0Provider } from '@auth0/auth0-react';
import 'bootstrap-icons/font/bootstrap-icons.css';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ReduxProvider store={store}>
    <Auth0Provider
      domain="dev-bntkajprrt6actt0.us.auth0.com"
      clientId="7jAWuPUKJOsP9gRbxPrCdzRAxU86yQrf"
      authorizationParams={{ redirect_uri: window.location.origin }}
    >
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Auth0Provider>
  </ReduxProvider>
);

reportWebVitals();
